import logEvent from '../../logEvent';

function logEventAssistedSearchFunctionality(code, data) {
  logEvent(`UFSF-${code}`, data);
}

export function logEventAssistedSearchFunctionalityIDVerified() {
  logEventAssistedSearchFunctionality('01');
}

export function logEventAssistedSearchFunctionalityCustomerSearch(data) {
  logEventAssistedSearchFunctionality('02', data);
}

export function logEventAssistedSearchFunctionalityCodeGenerated() {
  logEventAssistedSearchFunctionality('03');
}

export function logEventAssistedSearchFunctionalityCodeRegenerated() {
  logEventAssistedSearchFunctionality('04');
}

export function logEventAssistedSearchFunctionalityCodeEnteredSuccessfully() {
  logEventAssistedSearchFunctionality('05');
}

export function logEventAssistedSearchFunctionalityCodeEnteredUnsuccessfully(data) {
  logEventAssistedSearchFunctionality('06', data);
}

export function logEventAssistedSearchFunctionalityUpdateCustomerKYCClicked() {
  logEventAssistedSearchFunctionality('07');
}

export function logEventAssistedSearchFunctionalityAddPlanButtonButtonClicked() {
  logEventAssistedSearchFunctionality('08');
}

export function logEventAssistedSearchFunctionalityAddBeneficiaryButtonClicked() {
  logEventAssistedSearchFunctionality('09');
}

export function logEventAssistedSearchFunctionalityMakeContributeButtonClicked() {
  logEventAssistedSearchFunctionality('10');
}

export function logEventAssistedSearchFunctionalityCancelContributionClicked() {
  logEventAssistedSearchFunctionality('11');
}

export function logEventAssistedSearchFunctionalityEditContributionClicked() {
  logEventAssistedSearchFunctionality('12');
}

export function logEventAssistedSearchFunctionalityCustomerLogout() {
  logEventAssistedSearchFunctionality('13');
}

export function logEventAssistedSearchFunctionalityEmployeeLogout() {
  logEventAssistedSearchFunctionality('14');
}

export function logEventAssistedSearchFunctionalitySignedIn() {
  logEventAssistedSearchFunctionality('15');
}

export function logEventAssistedSearchFunctionalityOpenRESPButtonClicked() {
  logEventAssistedSearchFunctionality('16');
}
